import React from 'react';
import { ChevronRight, ChevronLeft, FoldHorizontal } from 'lucide-react';
import { stringMixin } from '../../utils/strings';

const ScreenerControl = ({
  metric,
  metricData,
  filterValues,
  onClear,
  onConditionChange,
  onValueChange
}) => {
  const handleSliderChange = (e) => {
    const value = e.target.value === '' ? '' : Number(e.target.value);
    onValueChange(metric, value);
  };

  const handleInputChange = (event) => {
    const value = event.target.value === '' ? '' : Number(event.target.value);
    onValueChange(metric, value);
  };

  const handleConditionChange = (newCondition) => {
    if (newCondition !== null) {
      onConditionChange(metric, newCondition);
    }
  };

  return (
    <div className="py-4 border-b border-gray-200 mb-6">
      {/* Header */}
      <div className="flex justify-between items-center gap-8">
        <span className="uppercase text-sm font-medium flex items-center gap-4">
          {/* Icon would go here */}
          {metric}
        </span>

        <div className="flex rounded-md overflow-hidden">
          <button
            onClick={() => handleConditionChange('greater')}
            className={`p-2 ${
              filterValues[metric]?.condition === 'greater'
                ? 'bg-blue-500 text-white'
                : 'bg-white hover:bg-gray-100'
            }`}
            title="Greater Than Value"
          >
            <ChevronRight size={20} />
          </button>
          <button
            onClick={() => handleConditionChange('less')}
            className={`p-2 ${
              filterValues[metric]?.condition === 'less'
                ? 'bg-blue-500 text-white'
                : 'bg-white hover:bg-gray-100'
            }`}
            title="Less Than Value"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => handleConditionChange('range')}
            className={`p-2 ${
              filterValues[metric]?.condition === 'range'
                ? 'bg-blue-500 text-white'
                : 'bg-white hover:bg-gray-100'
            }`}
            title="Value Range"
          >
            <FoldHorizontal size={20} />
          </button>
        </div>
      </div>

      {/* Controls */}
      <div className="mt-4 px-12">
        <div className="flex gap-8 items-center">
          <div className={'flex flex-col'}>
            <input
                type="range"
                value={filterValues[metric]?.value || 0}
                onChange={handleSliderChange}
                min={metricData?.min || 0}
                max={metricData?.max || 100}
                step={metricData?.step || 1}
                className="flex-grow"
            />
            <div className="flex justify-between mt-1">
              <span style={{fontSize: '9px'}}>{stringMixin.largeNumber(metricData?.min || 0)}</span>
              <span style={{fontSize: '9px'}}>{stringMixin.largeNumber(metricData?.max || 100)}</span>
            </div>
          </div>
          <input
              type="number"
              value={filterValues[metric]?.value || ''}
              onChange={handleInputChange}
              min={metricData?.min}
              max={metricData?.max}
              step={metricData?.step || 1}
              className="w-20 p-1 text-center border border-gray-200 rounded"
          />
        </div>
        {/* Min/Max Labels */}
      </div>
    </div>
  );
};

export default ScreenerControl;